import { render, staticRenderFns } from "./RelatorioTerceiro.vue?vue&type=template&id=45506909"
import script from "./RelatorioTerceiro.vue?vue&type=script&lang=js"
export * from "./RelatorioTerceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports